export default __webpack_public_path__ + "static/government-officials-2-2535aaa2117b1290d40a17f3c6e95bcd.png";